import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { sharedConfig } from '@/config/sharedConfig';
import { LANGUAGE_KEY } from '@/redux/reducers/languageSlice';

export const useSelectedLanguage = () => {
  return useSelector(
    (state: RootState) =>
      state.language.language ?? localStorage.getItem(LANGUAGE_KEY) ?? sharedConfig.defaultLocale,
  );
};
